import { useCallback } from "react";
import { isFunction } from "../../utils/is";
export var useComposedRef = function() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    return useCallback(function(node) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = refs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var ref = _step.value;
                if (ref != null) {
                    if (isFunction(ref)) {
                        ref(node);
                    } else {
                        try {
                            ref.current = node;
                        } catch (error) {
                            throw new Error("Cannot assign value \"".concat(node, "\" to ref \"").concat(ref, "\""));
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }, refs);
};
export default useComposedRef;
